/*
 * @创建文件时间: 2019-12-20 10:21:06
 * @Auther: lfq
 * @最后修改人        : lfq
 * @最后修改时间       : 2019-12-20 10:59:54
 * @联系Qq:1638245306
 * @文件介绍: 保存网页session
 */
const session = {}

/**
 * 保存session值
 * key:字段名,
 * value:值
 */
session.set = function(key,value){
    sessionStorage.setItem(key,value)
}

/**
 * 获取session值
 */
session.get = function(key){
    return sessionStorage.getItem(key)
}

session.remove = function(key){
    return sessionStorage.removeItem(key);
}

export default session